module.exports = __webpack_public_path__ + "img/cp-mp-r2.661d3d8e.jpg";